import api from '@/api';

const resource = 'gerencial/areaatuacao';

export default {
  postAreaAtuacao( data ) {
    return api.post( `${resource}`, data );
  },

  deletarAreaAtuacao( identificadorareaatuacaofuncionario ) {
    return api.delete( `${resource}/${identificadorareaatuacaofuncionario}`);
  },
};
